import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SettingsButton } from '@/components/Settings/SettingsButton';
import { SettingsModal } from '@/components/Settings/SettingsModal';
import GamePage from '@/pages/GamePage';
import { HomePage } from '@/pages/home/HomePage';
import ResultsPage from '@/pages/ResultsPage';
import '@/services/scoreSaveSubscription';
import backgroundImage from '@assets/images/background.jpg';
import { useAuthStore } from '@/store/authStore';
import ResultsPageSeason1 from './pages/ResultsPageSeason1';

function App() {
  const { initialize } = useAuthStore();
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <BrowserRouter>
      <SettingsButton onClick={() => setIsSettingsModalOpen((prev) => !prev)} />
      <SettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
      />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/results/season1" element={<ResultsPageSeason1 />} />
      </Routes>
      <img
        src={backgroundImage}
        alt="背景画像"
        className="fixed inset-0 size-full object-cover z-[-1]"
      />
    </BrowserRouter>
  );
}

export default App;
